import { jobWorkItemUpdateApi } from "src/domain/api/jobWorkItem/jobWorkItemUpdateApi"

type PayloadShape = Parameters<typeof jobWorkItemUpdateApi>[0]

export async function jobWorkItemUpdateService(payload: PayloadShape, token: string) {
	return await jobWorkItemUpdateApi(payload, token)
}
